"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatBp = formatBp;
var _getFormattedNumber = require("../internals/getFormattedNumber");
var _makeSpacesNonBreakable = require("../internals/makeSpacesNonBreakable");
var _formatNumber = require("./formatNumber");
/**
 * Returns parameter `value` formatted as the BPs (Bonus/Business Points).
 *
 * The `value` is formatted in the runtime culture in case:
 * - the {@link culture} setting is not provided,
 * - the number or bp formatting rules are not available in the {@link culture} setting.
 * @see {@link formatNumber} for more information.
 *
 * @param value Numeric value to format
 * @param culture Culture settings containing formatting rules
 * @returns `value` formatted as the BPs
 * @example
  // basic usage
  import { formatBp, useCulture } from '@ori/culture';
  const { culture } = useCulture();
  const formattedBp = formatBp(1234.567, culture);
 */
function formatBp(value, culture) {
  const {
    bpFormat,
    numberFormat
  } = culture ?? {};
  if (!bpFormat || !numberFormat) {
    // it is preferred by the business to display the value formatted in the runtime culture than no value at all
    return (0, _formatNumber.formatNumber)(value, culture);
  }
  return (0, _makeSpacesNonBreakable.makeSpacesNonBreakable)((0, _getFormattedNumber.getFormattedNumber)(value, bpFormat.decimals,
  // BP has only some different properties, otherwise it's just like a general number
  numberFormat.decimalSeparator, numberFormat.groupSizes, numberFormat.groupSeparator, {
    negativePattern: numberFormat.negativePattern,
    removeTrailingZeros: bpFormat.removeTrailingZeros
  }));
}
//# sourceMappingURL=formatBp.js.map